import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    delay?: number;
    error?: string;
}

const InputField: React.FC<InputFieldProps> = ({
    label,
    type = "text",
    placeholder,
    id,
    delay = 0,
    error,
    className = '',
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [focused, setFocused] = useState(false);
    const isPassword = type === "password";
    const inputType = isPassword ? (showPassword ? "text" : "password") : type;

    return (
        <div
            className={`flex flex-col gap-2 w-full animate-fade-in-up opacity-0 ${className}`}
            style={{ animationDelay: `${delay}ms`, animationFillMode: 'forwards' }}
        >
            <label
                htmlFor={id}
                className={`text-base font-semibold font-['Manrope'] transition-colors duration-200 ${focused ? 'text-[#015FA6]' : 'text-[#015FA6]/80'}`}
            >
                {label}
            </label>
            <div className="relative group">
                <input
                    id={id}
                    type={inputType}
                    placeholder={placeholder}
                    onFocus={(e) => {
                        setFocused(true);
                        props.onFocus?.(e);
                    }}
                    onBlur={(e) => {
                        setFocused(false);
                        props.onBlur?.(e);
                    }}
                    className={`
            w-full h-[60px] px-5 bg-[#F7FAFC] border rounded-xl text-[#414D63] text-base
            placeholder-[#015FA6]/40 font-['Manrope'] transition-all duration-300
            ${error
                            ? 'border-red-500 focus:border-red-500 ring-red-500/10'
                            : focused
                                ? 'border-[#015FA6] ring-4 ring-[#015FA6]/10 shadow-sm transform -translate-y-[1px]'
                                : 'border-[#CBD5E0] hover:border-[#015FA6]/50'
                        }
            focus:outline-none
          `}
                    {...props}
                />
                {isPassword && (
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 -translate-y-1/2 text-[#015FA6]/60 hover:text-[#015FA6] transition-colors p-2 rounded-full hover:bg-[#015FA6]/5"
                    >
                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </button>
                )}
            </div>
            {error && (
                <p className="text-red-500 text-sm mt-1 font-['Manrope'] animate-fade-in">
                    {error}
                </p>
            )}
        </div>
    );
};

export default InputField;
